/**
 * Бэкенд помечает удалённый клиентом завершённый заказ статусом DONE_DELETED
 * (см. OrderStatus.DONE_STATUSES). Для админки это тот же «Завершен».
 */
const DONE_ALIASES = ['DONE_DELETED'];

export const normalizeOrderStatus = (status) =>
  DONE_ALIASES.includes(status) ? 'DONE' : status;

export default normalizeOrderStatus;
